package dev.lingvo.site.components.studio.editor

import androidx.compose.runtime.Composable
import dev.lingvo.site.i18n.t
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.LMuted
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** The scene catalog is injected by the looks owner, so unavailable scenes are never invented. */
@Composable
internal fun ScenePicker(state: StudioUiState, dispatch: (StudioIntent) -> Unit) {
    Div(attrs = { style { property("display", "grid"); property("gap", Space.SM.toString()) } }) {
        Text(t("studio.editor.scene_picker.scene", "Scene"))
        state.scenes.forEach { scene ->
            Div(attrs = { attr("data-scene", scene.kind.name); style { property("display", "grid"); property("gap", Space.XS.toString()) } }) {
                StudioButton(sceneLabel(scene.kind), state.editable) { dispatch(StudioIntent.Scene(scene)) }
                LMuted(sceneDescription(scene.kind))
            }
        }
    }
}
